import React,{useState} from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, } from "reactstrap";

const TaskCommentsModal=({ isOpen, toggle, comments=[], onComment, })=>{
  const [message,setMessage]=useState("");
  return(
    <Modal isOpen={isOpen} toggle={toggle} centered >
      <ModalHeader toggle={toggle}> Task Comments </ModalHeader>
      <ModalBody>
        <div className="d-flex flex-column gap-2 mb-3">
          {comments.map((c,i)=>(
            <div key={i} className="border rounded p-2" >
              <div className="fw-semibold"> {c.user} </div>
              <div className="small text-muted"> {c.message} </div>
            </div>
          ))}
        </div>
        <Input type="textarea" rows={4} value={message} onChange={(e)=> setMessage(e.target.value) } />
      </ModalBody>

      <ModalFooter>
        <Button color="light" onClick={toggle} > Close </Button>
        <Button color="primary" onClick={()=> onComment(message) } > Send </Button>
      </ModalFooter>
    </Modal>
  );
};
export default TaskCommentsModal;
